module.exports = __webpack_public_path__ + "static/media/new-logo.fe1e65c8.png";